/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component, Fragment } from "react";
import { Button, Checkbox, Modal, Select, Switch  , AutoComplete,Tooltip} from "antd";
import postService from "../../../services/httpService";
import imageIcon from "../../../assets/images/Oval.png";
import Storage from "../../../services/local-store";
import CheckboxGroup from "antd/lib/checkbox/Group";
import { EditOutlined,FieldTimeOutlined } from '@ant-design/icons';
import "./doctor.css";
import userTrackService from "../../../services/usertrack-service";
import {socket} from '../Assign/index';

class DoctorCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      queueDoctors: [],
      disableShowDoctorsList: true,
      selectedDoctorforRoom: "",
      visible: false,
      isLoading: false,
      tvstatus: null,
      modalvisible: false,
      rejectbreakmodalvisible: false,
      confirmLoading: false,
      mappedRooms: [],
      mappedRoomsForQidCheck: [],
      multiRoomsModalvisible: false,
      checkedTransferRooms: [],
      changedDoctorIdForQue: '',
      dataSource: [],
      inputValue: "",
      switchOn: true,
      doctorbreakmodalvisible: false,
      doctorBreakReason:"",
      doctorBreakReasonsforDropdown:[],
      ModalText:"",
      clicked:false,
      ModalError:false,
      breakRejectReason:"",
      view:"",
    };
  }

  componentDidMount() {
    this.getQueueDoctorsForAssign();
    const selectedDoctorName = sessionStorage.getItem(`selectedDoctorName_${this.props.item.roomnumber}`);
      if (selectedDoctorName) {
        this.setState({ inputValue: selectedDoctorName });
      }
  }

  // refreshData() {
  //   // setInterval()
  //   this.getQueueDoctorsForAssign();
  //   this.props.refreshMultipleQueues();
  // }
  showBreakTimeInQueue(value) {
    
   if(this.state.doctorBreakReason != ""){
      this.setState({ doctorbreakmodalvisible: false }); 
       let obj = {
                    queue_doctor_id:this.props.item.queue_doctor_id,
                    queuelistid:this.props.item.queuelistid,
                    doctorname:this.props.item.doctorname,
                    reason:this.state.doctorBreakReason,
        };
              this.activateLoader();
                let Userlogobj = {
                  user: JSON.parse(Storage.get("user")),
                  action: "doctor_break",
                  date: new Date(),
                  meta: obj,
                };
                 userTrackService(Userlogobj);
                postService("storeDoctorBreakDetails", "POST", {
                  data: obj,
                }).then((res) => {
                  let Userlogobjres = {
                    user: JSON.parse(Storage.get("user")),
                    action: "doctor_break - response",
                    date: new Date(),
                    meta: res,
                  };
                  userTrackService(Userlogobjres);
                  this.deActivateLoader();
                  if (socket.readyState === WebSocket.OPEN) {
                    console.log('WebSocket connection established doctor break.');
                    // this.onStartQ(queueitem, "withoutassign")
                     const jsonString = JSON.stringify({data:"doctorbreak"});
                    socket.send(jsonString);
                  };
                  //this.props.refreshData();
                  
                  //  this.props.refreshSingleQueue(obj, "doctor_break");
                  //}
                });
              }
              
      
   else {
    this.setState({ ModalError: true });
  }
  }
  showDoctorsList(item) {
    if(item.patients.length) {
      this.setState({ modalvisible: true });
    }else {
      this.setState({ disableShowDoctorsList: false });
      this.getQueueDoctorsForAssign();
    }
  }
  showDoctorBreakReasonsModal = () => {
    this.setState({
      doctorbreakmodalvisible: true,
      doctorBreakReason:"",
      ModalError: false,
    });
  };
  getDoctorBreakReason(value){
    this.setState({ doctorBreakReason: value });
  }
  showDoctorsBreakList(item) {
  if(!item.queue_doctor_id){
      this.setState({ rejectbreakmodalvisible: true });
      this.setState({ breakRejectReason:"Please select the doctor."});
    }
    else if(item.patients.length) {
      let data=item.patients.filter(item=>item.current_workflow_stage_id=='4');
      if(data.length){
      this.setState({ rejectbreakmodalvisible: true });
      this.setState({ breakRejectReason:    "Before taking the break, complete the procedure for the existing patient or remove the patient from the queue." });}
      else{
        this.getDoctorBreakReasons();
      this.setState({ ModalText: "Choose reason for break1 " });
      this.hide();
      this.showDoctorBreakReasonsModal();
      }
    }
    else {
      this.getDoctorBreakReasons();
      this.setState({ ModalText: "Choose reason for break2 " });
      this.hide();
      this.showDoctorBreakReasonsModal();
   }
  }
  hide = () => {
    this.setState({
      clicked: false,
    });
  };
 
  selectDoctor(value) {
    this.setState({ thisDocRoomnumber: '' });
    let doctorDetails = this.state.queueDoctors && this.state.queueDoctors.filter((doctor) => doctor.name === value);
    let doctorId = doctorDetails.length && doctorDetails[0].id ? doctorDetails[0].id : null;
    let mappedRooms = this.props.props.QueueList.filter((queue, key) => queue.queue_doctor_id === doctorId && queue.roomnumber != this.props.item.roomnumber).map(queue => queue.roomnumber)
    let mappedRoomsForQidCheck = this.props.props.QueueList.filter((queue, key) => queue.queue_doctor_id === doctorId && queue.roomnumber != this.props.item.roomnumber).map(queue => ({roomnumber: queue.roomnumber, queuelistid: queue.queuelistid}))
    if(mappedRooms.length && doctorId!==null){
      this.setState({multiRoomsModalvisible: true, mappedRoomsForQidCheck: mappedRoomsForQidCheck, mappedRooms: mappedRooms, selectedDoctorforRoom: value, disableShowDoctorsList: value && true, changedDoctorIdForQue: doctorId});
      // this.updateQueueDoctorId(doctorId, mappedRooms, mappedRoomsForQidCheck);
    }else{
      this.setState((state) => ({multiRoomsModalvisible: false, mappedRoomsForQidCheck: mappedRoomsForQidCheck, mappedRooms: mappedRooms, selectedDoctorforRoom: value, disableShowDoctorsList: value && true, changedDoctorIdForQue: doctorId }), () => {
        this.setState({multiRoomsModalvisible: false, mappedRoomsForQidCheck: mappedRoomsForQidCheck, mappedRooms: mappedRooms, selectedDoctorforRoom: value, disableShowDoctorsList: value && true, changedDoctorIdForQue: doctorId});
    });
      
      // this.setState({mappedRooms: [], selectedDoctorforRoom: value, disableShowDoctorsList: value && true,});
      this.updateQueueDoctorId(doctorId, mappedRooms, mappedRoomsForQidCheck);
    }
    //localStorage.setItem(`selectedDoctorName_${this.props.item.roomnumber}`, value);
    sessionStorage.setItem(`selectedDoctorName_${this.props.item.roomnumber}`, value);
    //localStorage.removeItem(`selectedDoctorName_${this.props.item.roomnumber}`);
    //sessionStorage.clear();
  }
  activateLoader() {
    this.setState({ isLoading: true });
  }
  deActivateLoader() {
    this.setState({ isLoading: false });
  }
  doctorbreakhandleOk = () => {
    this.setState({
      confirmLoading: false,
      doctorbreakmodalvisible: false,
    });
  };
  doctorbreakhandleCancel = () => {
    this.setState({
      doctorbreakmodalvisible: false,
    });
  };
  
  // getQueueDoctorsBasedOnQueue() {
  //   let obj = {
  //     queue_list_id: this.props.item.queuelistid
  //       ? this.props.item.queuelistid
  //       : "",
  //   };
  //   postService("QueueListIdDoctors", "POST", { data: obj }).then((res) => {
  //     if (res) {
  //       this.setState({ queueDoctors: res.data });
  //     }
  //   });
  // }

  getQueueDoctorsForAssign() {
    let userdata = JSON.parse(Storage.get("user_data"));

    postService("getQueueDoctorsForAssign", "POST", {
      data: { unit_id: userdata.unitid },
    }).then((res) => {
      if (res) {
                // console.log("responseddoctors",res.data);
               this.setState({ queueDoctors: res.data });
              }
    });
  }
  getDoctorBreakReasons() {
    postService("getDoctorBreakReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ doctorBreakReasonsforDropdown: res.data });
      }
    });
    
  }

  updateQueueDoctorId(doctorId) {
    // let doctorDetails =
    //   this.state.queueDoctors &&
    //   this.state.queueDoctors.filter((doctor) => doctor.name === doctorName);
    // console.log("doctorDetails", doctorDetails);

    let QlistId = this.props.item.queuelistid ? this.props.item.queuelistid : "";
    // console.log("QlistId", QlistId);

    // let doctorId =
    //   doctorDetails.length && doctorDetails[0].id ? doctorDetails[0].id : null;

    let obj = {
      data: {
        queue_list_id: QlistId,
        doctor_id: doctorId,
        doctorMappedRooms: this.state.mappedRoomsForQidCheck,
      },
    };
    this.activateLoader();
    postService("updateQueueDoctorId", "POST", obj)
      .then((res) => {
        if (res) {
          this.deActivateLoader();
          // this.setState({ queueDoctors: res.data });
          
          if (res.status) {
            if (socket.readyState === WebSocket.OPEN) {
              console.log('WebSocket connection established Checkin Checkin.');
              // this.onStartQ(queueitem, "withoutassign")
              const jsonString = JSON.stringify({data:"doctordropdown"});
              socket.send(jsonString);
            };
            //this.props.refreshData();
            //this.props.refreshQueueListData();
            Modal.success({
              maskClosable: false,
              zIndex: 1040,
              title: "success message",
              content: "Updated Queue Doctor Successfully",
              onOk: () => {
                // this.setState({ visible: false });
                // this.setState({visible: false, multiRoomsModalvisible: false, mappedRoomsForQidCheck: [], mappedRooms: [], selectedDoctorforRoom: "", disableShowDoctorsList: true, changedDoctorIdForQue: ""});
                this.setState({visible: false, multiRoomsModalvisible: false, mappedRoomsForQidCheck: [], mappedRooms: [], disableShowDoctorsList: true, changedDoctorIdForQue: ""});
              },
            });
          } else {
            Modal.error({
              maskClosable: false,
              zIndex: 1040,
              title: "Error",
              content: "" + res.data + "",
            });
          }
        }
      })
      .catch((err) => console.log("updateQueueDoctorId", err));
  }

  onOnOffChange(value, room) {
    let status = value === true ? "1" : "0";
    this.setState({switchOn:value});
    this.setState({ tvstatus: status });
    let obj = {
      data: {
        queue_list_id: room.queuelistid,
        status: status,
      },
    };

    postService("setQueueTVDisplaySetting", "POST", obj).then((res) => {
   });
  }
  onSearch(val) {
    
  }

  radiology() {
    let item = this.props.item;  
    return (
      <>
        {/* <div class="row"> */}
        {/* <div class="col-2">
        <img alt="" src={imageIcon} class="DoctorImgOval" />
      </div> */}
        {/* <div class="col-6 pt-2 pl-4"> */}
        {/* <span class="OperatorName">
          Dr. {item.doctorname ? item.doctorname : "Anil Doctor1"}
          <span class="row OperatorType">
            {item.doctorstatus ? item.doctorstatus : "Cardiologist"}
          </span>
        </span> */}
        {/* </div> */}
        <div class="displaySpaceBetween">
          <div className="col-8">
            <span className="operatorRoom">Room: {item.roomnumber}</span>
          </div>
          <div className="col-3 text-center" >
            <Switch
              checkedChildren="ON"
              unCheckedChildren="OFF"
              style={{ borderRadius: "40px" }}
              // checked
              onChange={this.onOnOffChange.bind(this)}
            />
          </div>
        </div>
        {/* </div> */}
      </>
    );
  }
  OPD() {
    const { slug } = this.props.match.params;
    let item = this.props.item;
    let queueDoctors = this.state.queueDoctors;
    let { selectedDoctorforRoom, tvstatus } = this.state;
    let checked =
      tvstatus === null
        ? item.enable_tv === "1"
          ? true
          : item.enable_tv === "0" && false
        : tvstatus === "1"
        ? true
        : tvstatus === "0" && false;

    const Option = Select.Option;
    return (
      <>
        {slug !== "doctor-view" && (
          <div style={{display:"flex"}}>
            <Select
            showSearch
              style={{ width: "80%" }}
              value={
                selectedDoctorforRoom
                  ? selectedDoctorforRoom
                  : item.doctorname
                  ? item.doctorname
                  : "No Doctor"
              }
              onChange={this.selectDoctor.bind(this)}
              onSearch={this.onSearch.bind(this)}
              disabled={this.state.disableShowDoctorsList}
            >
              <Option value="nodoctor" key="nodoctor">
                No Doctor
              </Option>
              {queueDoctors
                // .filter(
                //   (doctor) => doctor.name !== this.state.selectedDoctorforRoom
                // )
                .map((doctor) => (
                  <Option value={doctor.name} key={doctor.id}>
                    {doctor.name}
                  </Option>
                ))}
            </Select>
            {/* <AutoComplete
                style={{ width: "80%"}}
              //  value={selectedDoctorforRoom ? item.doctorname : this.state.inputValue}
                // value={this.state.inputValue}
                //value={selectedDoctorforRoom ? selectedDoctorforRoom : this.state.inputValue}
                value = { selectedDoctorforRoom ? selectedDoctorforRoom : item.doctorname?item.doctorname: this.state.inputValue}
                placeholder="Enter Doctor Name"
                // onChange={this.selectDoctor.bind(this)}
                onChange={(value) => {
                  this.setState({ inputValue : value }, () => {
                    const filteredDoctors = queueDoctors.filter((doctor) =>
                      doctor.name.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    );
                   this.setState({ dataSource: filteredDoctors });
                  });
                  
                }}
                onSelect={(value) => {
                  // Handle the selection of an option here (e.g., store the selected value)
                  this.selectDoctor(value);
                }}
                disabled={this.state.disableShowDoctorsList}
                dataSource={[
                  <Option value="nodoctor" key="nodoctor">
                    No Doctor
                  </Option>,
                  ...queueDoctors
                    .filter((doctor) =>
                      doctor.name.toLowerCase().includes(this.state.inputValue.toLowerCase())
                    )
                    .map((doctor) => (
                      <Option value={doctor.name} key={doctor.id}>
                        {doctor.name}
                      </Option>
                    ))
                ]}
                inputStyle={{ color: "black" }}
              >
              </AutoComplete> */}
              <Tooltip title="Change Doctor">
              <Button
              className="edit_size"
    style={{ width: "10%", color: "black" }}
    icon={<EditOutlined />}
    onClick={this.showDoctorsList.bind(this, item)}
/></Tooltip>
<Tooltip title="Take a Break">
<Button
    className="edit_size"
    style={{ width: "10%", color: "#6c3964" }}
    icon={<FieldTimeOutlined />}
    onClick={this.showDoctorsBreakList.bind(this, item)}
/></Tooltip>

            {/* <Button
              style={{ width: "20%", color:"black" }}
              icon="edit"
              onClick={this.showDoctorsList.bind(this, item)}
            /> */}
          </div>
        )}
        <div class="displaySpaceBetween mt-3">
          <div className="col-8 pl-0">
            <span className="operatorRoom">Room: {item.roomnumber}</span>
          </div>
          {slug == "doctor-view" &&
         <Tooltip title="Take a Break">
          <Button
    className="edit_size"
    style={{ width: "10%", color: "#6c3964" ,border:"none",paddingBottom:"12px"}}
    icon={<FieldTimeOutlined />}
    onClick={this.showDoctorsBreakList.bind(this, item)}
/></Tooltip>}
          <div className= {slug=="doctor-view"?"col-4 text-center":"col-3 text-center"}>
            <Tooltip title="TV-Display">
            <Switch
              checkedChildren="ON"
              unCheckedChildren="OFF"
              // style={{ borderRadius: "40px", backgroundColor: this.state.switchOn ? '#8c2ba4' : 'lightgray' }}
              style={{ borderRadius: "40px", backgroundColor:checked ? '#8c2ba4' : 'lightgray' }}
              checked={checked}
              onChange={(status) => this.onOnOffChange(status, item)}
            /></Tooltip>
          </div>

        </div>
      </>
    );
  }
  modalhandleOk = () => {
    this.setState({modalvisible: false})
  }
  rejectbreakmodalhandleOk = () => {
    this.setState({rejectbreakmodalvisible: false})
  }
  multiRoomshandleOk = async() => {
    let {checkedTransferRooms, mappedRoomsForQidCheck, changedDoctorIdForQue} = this.state;
    // let mappedRoomsForQidCheck =  this.state.mappedRoomsForQidCheck.filter(stu => stu.roomnumber === this.state.checkedTransferRooms);
    let newMappedRooms = [];
    await checkedTransferRooms.map(checkedRoom => {
      mappedRoomsForQidCheck.map(mappedRoom => {
        if(checkedRoom === mappedRoom.roomnumber){
          newMappedRooms.push(mappedRoom.queuelistid)
        }
      })
    })
    this.setState({mappedRoomsForQidCheck: newMappedRooms})
    this.updateQueueDoctorId(this.state.changedDoctorIdForQue)
  }
  multiRoomshandleCancel = () => {
    this.setState({multiRoomsModalvisible: false})
  }
  onSelectCheckbox = (values) => {
    this.setState({checkedTransferRooms: values})
  }
  
  render() {
    const Option = Select.Option;
    const {
      modalvisible,
      confirmLoading,
      multiRoomsModalvisible,
      mappedRooms,
      rejectbreakmodalvisible,
      doctorbreakmodalvisible,
      doctorBreakReason,
      ModalText,
      ModalError,
    } = this.state;
    const { slug } = this.props.match.params;
    let item = this.props.item;
    let queueDoctors = this.state.queueDoctors;
    const { selectedDoctorforRoom, inputValue } = this.state;

    return (
      <Fragment>
        <div
          className="DoctorDetailsCard"
          style={{
            height: slug === "doctor-view" && "12%",
            width: slug === "doctor-view" && "100%",
            margin: slug === "doctor-view" && "0 0 1px",
            padding: slug === "doctor-view" && "0 10px 20px",
          }}
        >
          {item && item.queue_type === "Radiology" && this.radiology()}
          {item && item.queue_type === "OPD Consultation" && this.OPD()}
        </div>
        <Modal
                visible={doctorbreakmodalvisible}
                onOk={this.doctorbreakhandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.doctorbreakhandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the Reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={doctorBreakReason}
                    style={{ width: "100%" }}
                    onChange={this.getDoctorBreakReason.bind(this)}
                  >
                    <Option value="">Select the Reason</Option>
                    {this.state.doctorBreakReasonsforDropdown.map((d, i) => {
                      return (
                        <Option value={d.id} key={i}>
                          {d.reason}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.showBreakTimeInQueue.bind(this,"break")}
                >
                  Submit
                </Button>
              </Modal>
        <Modal
          style={{ top: "25%" }}
          visible={modalvisible}
          onOk={this.modalhandleOk}
          confirmLoading={confirmLoading}
          footer={[
            <Button type="primary" onClick={this.modalhandleOk}>
              Ok
            </Button>,
          ]}
        >
          <p className="mt-3">
             Few patients are available in the queue. Before changing the doctor, complete the procedure for the existing patients or remove the patients from the queue. </p>
        </Modal>
        <Modal
          style={{ top: "25%" }}
          visible={rejectbreakmodalvisible}
          onOk={this.rejectbreakmodalhandleOk}
          confirmLoading={confirmLoading}
          footer={[
            <Button type="primary" onClick={this.rejectbreakmodalhandleOk}>
              Ok
            </Button>,
          ]}
        >
          <p className="mt-3"> {this.state.breakRejectReason}
         </p>
        </Modal>
        <Modal
          style={{ top: "25%" }}
          visible={multiRoomsModalvisible}
          onOk={this.multiRoomshandleOk}
          onCancel={this.multiRoomshandleCancel}
          confirmLoading={confirmLoading}
        >
          <p className="mt-3"> Patients are available in the queue. Select the queue from which tranfer the patients to this queue. </p>
          <CheckboxGroup options={mappedRooms} onChange={this.onSelectCheckbox}/>
        </Modal>
      </Fragment>
    );
  }
}

export default DoctorCard;
